<tab-container>
    <ng-template tab-pane title="Fragrance" [active]="true">
        <fragrance [materialId]="material.materialId" ></fragrance>
    </ng-template>
    <ng-template tab-pane title="TL History">
    </ng-template>
</tab-container>
